export enum DirectorShareAcnQuestion {
  AddCheck = "DIRECTOR_ADD_CHECK",
  AddShares = "DIRECTOR_ADD_SHARES",
}

export const DIRECTOR_FIELD_TO_PATH: Record<DirectorShareAcnQuestion, string> = {
  [DirectorShareAcnQuestion.AddCheck]: "add-check",
  [DirectorShareAcnQuestion.AddShares]: "add-shares",
};
